import React from 'react';
import UserInvite from '../components/user-invitation-view';
import environment from 'lib/environment';
import {
  getForgotPasswordUrl,
} from 'lib/utility-functions';

export class UserInvitationContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    const urlParams = new URLSearchParams(window.location.search);
    this.state = {
      invitationId:  urlParams.get('id') || '',
      acceptInvitationURL: `${environment.get().oauth.redirect_url}acceptinvitation?id=${urlParams.get('id')}`
    };
  }

  navToSignIn = () => {
    window.location.assign(this.state.acceptInvitationURL);
  };

  render() {
    return (
      <UserInvite
        navToSignIn={this.navToSignIn}
        resetPwdUrl={getForgotPasswordUrl()}
      />
    );
  }
}

export default UserInvitationContainer;
